module.exports = __webpack_public_path__ + "img/vitaparcour_with_bro.016f991f.jpg";